export enum EditNavSelection {
  StudyProtocolHome,
  Criteria,
  VisitChecklist,
  VisitChecklistLegend,
  Reminders
}